import React from 'react'

const ThankYou = () => {
  const goHome = () => {
    window.location.hash = ''
    window.scrollTo({ top: 0, behavior: 'smooth' })
  }

  return (
    <section className="min-h-[60vh] flex items-center justify-center bg-white">
      <div className="container mx-auto px-6 text-center py-24">
        <h1 className="text-4xl md:text-5xl font-serif font-bold text-brand-green mb-4">Grazie!</h1>
        <p className="text-lg text-brand-text/80 max-w-2xl mx-auto mb-10">
          La tua richiesta è stata inviata correttamente. Ti contatteremo al più presto.
        </p>
        <button
          onClick={goHome}
          className="inline-flex items-center gap-2 bg-brand-green text-white font-semibold py-3 px-6 rounded-md hover:bg-brand-light-green transition-colors"
        >
          ← Torna alla homepage
        </button>
      </div>
    </section>
  )
}

export default ThankYou